import axios from 'axios';
import config from '../config';
import { message } from 'antd';
export const SERVER_URL = config.api;
export const API_URL = SERVER_URL;

axios.defaults.withCredentials = true;
let isRedirecting = false;

export const request = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  responseType: 'json',
  transformResponse: [
    (data) => {
      if (data) {
        if (data.data) {
          if (data.data.code) {
            if (data.data.code === -19) {
              let user = JSON.parse(localStorage.getItem('@@auth_sas_logged'));

              if (user !== null) {
                user.active = false;
                localStorage.setItem('@@auth_sas_logged', JSON.stringify(user));
              } else {
                localStorage.clear();
              }
            }
          }
        }
      }
      return data;
    },
  ],
});

request.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;
      message.warning('Tu sesión ha expirado. Redirigiendo...', 2);
      setTimeout(() => {
        localStorage.removeItem('@@auth_user');
        window.location.href = '/login';
      }, 2000);
    }

    return Promise.reject(error);
  },
);

export const reqintel = axios.create({
  baseURL: 'http://187.189.239.183:8080/',
  withCredentials: false,
  responseType: 'json',
  transformResponse: [
    (data) => {
      return data;
    },
  ],
});
